import { render, staticRenderFns } from "./ad-batch.vue?vue&type=template&id=650f33b8&scoped=true"
import script from "./ad-batch.vue?vue&type=script&lang=js"
export * from "./ad-batch.vue?vue&type=script&lang=js"
import style0 from "./ad-batch.vue?vue&type=style&index=0&id=650f33b8&prod&lang=scss&scoped=true"
import style1 from "./ad-batch.vue?vue&type=style&index=1&id=650f33b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f33b8",
  null
  
)

export default component.exports